<div class="table-responsive">
	<table class="table table-borderless ys-table thead-white">
		<thead>
			<tr>
				<th *ngFor="let tableHeader of tableConfig.headers"
					[ngClass]="{
                        'large-table-header': tableHeader.isLarge,
                        'small-table-header': !tableHeader.isLarge,
                        'sortable': tableHeader.sortId
                    }"
					(click)="
						tableHeader.sortId &&
						emitSortAction({
                            tableHeader,
                            sortDirection: highlightSortIcon({ tableHeader: this.tableHeader, sortDirection: 'ASC'}) ? 'DESC' : 'ASC'
                        })"
					scope="col">
					{{ tableHeader.name | titlecase }}<div
						*ngIf="tableHeader.sortId"
						[ngClass]="{
							'asc': highlightSortIcon({
										tableHeader: this.tableHeader,
										sortDirection: 'ASC'
									}),
							'desc': highlightSortIcon({
                                tableHeader: this.tableHeader,
                                sortDirection: 'DESC'
                            })
						}"
					></div>
					<form [formGroup]="filterForm" *ngIf="tableConfig.isFilterable">
						<app-filter-controls [filterForm]="filterForm"
											 [filterInput]="tableHeader.filterInput"
											 [paginationParams]="paginationParams"></app-filter-controls>
					</form>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let entity of tableConfig.data;  let ei = index"
				class="toplined">
				<td *ngFor="
                        let property of tableConfig.properties;
                        let i = index
                    ">
					<ng-container *ngIf="property?.isDate">
						{{
                            entity[property.name] | date: "h:mm a dd MMM yyyy"
                        }}
					</ng-container>
					<ng-container *ngIf="property?.titleCase">
						<span [ngClass]="{
                                'wrap-final-text':
                                    i === tableConfig.properties.length - 1
                            }">
							{{ entity[property.name] | titlecase }}
						</span>
					</ng-container>
					<ng-container *ngIf="property?.translator">
						{{ property.translator(entity[property.name]) }}
					</ng-container>
					<ng-container *ngIf="!property.isDate && !property.titleCase && !property.translator">
						{{ entity[property.name] }}
					</ng-container>
				</td>
				<td class="row-icon">
					<ng-container *ngIf="tableConfig.showButtons; else icons">
						<a *ngFor="let rowAction of tableConfig.rowActions"
							(click)="
                                emitRowAction({
                                    actionType: rowAction,
                                    entity: entity
                                })
                            "
							class="btn btn-light btn-sm">
							{{ rowAction }}
						</a>
					</ng-container>
					<ng-template #icons>
						<ng-container *ngFor="let rowAction of tableConfig.rowActions">
							<i *ngIf="rowAction === 'View'"
								(click)="
                                    emitRowAction({
                                        actionType: rowAction,
                                        entity: entity
                                    })
                                "
								data-toggle="tooltip"
								data-placement="top"
								title="View"
								class="fa fa-eye"></i>

							<div class="tooltip-trigger ms-2 d-inline-block" *ngIf="rowAction === 'Tooltip' && tableConfig.actionTooltipTemplate"
								 (click)="tooltipClick(ei, entity)"
								 (mouseenter)="showRowTooltip[ei] = true"
								 (mouseleave)="showRowTooltip[ei] = false"
								 >
								<svg-icon [class]="'d-flex'" [svgClass]="'icon--info'" src="assets/images/icon-info.svg"></svg-icon>
								<ng-container *ngIf="showRowTooltip[ei]">
									<span [@fadeIn] (mouseenter)="showRowTooltip[ei] = true" class="custom-tooltip small shadow-lg">
										<ng-container [ngTemplateOutlet]="tableConfig.actionTooltipTemplate" [ngTemplateOutletContext]="{ $implicit: entity }"></ng-container>
									</span>
								</ng-container>
							</div>
							<i *ngIf="rowAction === 'Delete'"
								(click)="
                                    emitRowAction({
                                        actionType: rowAction,
                                        entity: this.entity
                                    })
                                "
								data-toggle="tooltip"
								data-placement="top"
								title="Delete"
								class="fa fa-times"></i>
						</ng-container>
					</ng-template>
				</td>
			</tr>
		</tbody>
	</table>
	<div *ngIf="tableConfig.data.length === 0"
		class="no-results mb-3">
		<p>
			{{ tableConfig.noResultsFound }}
		</p>
	</div>
</div>
<app-pagination *ngIf="paginationParams"
	[params]="paginationParams"
	(update)="this.emitFilterAction($event)"></app-pagination>
